import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { LayoutTemplate } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useScope } from '@/auth/useScope';
import { useAppStore } from './appStore';

export function WorkspaceLayoutsMenu() {
  const { t } = useTranslation('common');
  const canRead = useScope('workbench:templates:read');
  const canWrite = useScope('workbench:templates:write');
  const openLayoutSaveDialog = useAppStore((s) => s.openLayoutSaveDialog);
  const openLayoutLoadDialog = useAppStore((s) => s.openLayoutLoadDialog);

  if (!canRead && !canWrite) {
    return null;
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          aria-label={t('layouts.menuLabel', { defaultValue: 'Workspace layouts' })}
          className="rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          data-testid="workspace-layouts-menu-trigger"
        >
          <LayoutTemplate size={16} />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={6}
          className="z-50 min-w-[220px] overflow-hidden rounded-md border border-border bg-popover p-1 text-sm text-popover-foreground shadow-wb-md"
        >
          {canWrite && (
            <DropdownMenu.Item
              onSelect={(event) => {
                event.preventDefault();
                openLayoutSaveDialog();
              }}
              className="cursor-pointer rounded px-2 py-1.5 text-sm outline-none hover:bg-muted focus:bg-muted"
              data-testid="workspace-layout-save-action"
            >
              {t('layouts.saveAction', { defaultValue: 'Save layout…' })}
            </DropdownMenu.Item>
          )}
          {canRead && (
            <DropdownMenu.Item
              onSelect={(event) => {
                event.preventDefault();
                openLayoutLoadDialog();
              }}
              className="cursor-pointer rounded px-2 py-1.5 text-sm outline-none hover:bg-muted focus:bg-muted"
              data-testid="workspace-layout-load-action"
            >
              {t('layouts.loadAction', { defaultValue: 'Load layout…' })}
            </DropdownMenu.Item>
          )}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
